export default __webpack_public_path__ + "static/media/img5.86e70707.png";